import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  BarChart2,
  Droplets,
  Settings,
  Box,
  FileText,
} from "lucide-react";
import LogoSmall from "../../assets/images/logosmallwhite.png";
import LargeSmall from "../../assets/images/logowhitelarge.png";
import LogoForWhiteTheme from "../../assets/images/logoforwhitetheme.png";
import SmallLogoForWhiteTheme from "../../assets/images/logosmall.png";
import { useTheme } from "../../context/ThemeContext";
import { X } from "lucide-react";

export function Sidebar({ onItemClick, isCollapsed, isMobile, closeSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme, colors } = useTheme();
  const pathName = location.pathname.toLowerCase();
  const data = JSON.parse(localStorage.getItem("MCData")) || {};
  const userType = data?.type;

  const navItems = [
    {
      id: "home",
      label: "Home",
      icon: Home,
      path: "/dashboard",
    },
    {
      id: "water-usage",
      label: "Water Usage",
      icon: Droplets,
      path: "/waters",
      isActive: ["/waters", "/wateragg", "/watermeterreadings"].includes(
        pathName,
      ),
    },
    {
      id: "analytics",
      label: "Analytics",
      icon: BarChart2,
      path: "/totalflow",
      isActive: ["/totalflow", "/predictiveanalysis", "/anomaly"].includes(
        pathName,
      ),
    },
    // {
    //   id: "digital-twin",
    //   label: "Digital Twin",
    //   icon: Box,
    //   path: "/schematics",
    //   isActive: ["/schematics", "/stats", "/devices"].includes(pathName),
    // },
    ...(userType !== "U"
      ? [
          {
            id: "digital-twin",
            label: "Digital Twin",
            icon: Box,
            path: "/schematics",
            isActive: ["/schematics", "/stats", "/devices"].includes(pathName),
          },
        ]
      : []),
    {
      id: "reports-alerts",
      label: "Reports & Alerts",
      icon: FileText,
      path: "/alert",
      isActive: ["/alert", "/notificationss", "/outliers"].includes(pathName),
    },
    // {
    //   id: "account-settings",
    //   label: "Account Settings",
    //   icon: Settings,
    //   path: "/settingsuser",
    //   isActive: [
    //     "/settingsuser",
    //     "/list",
    //     "/accountnames",
    //     "/registration",
    //   ].includes(pathName),
    // },
    {
      id: "account-settings",
      label: "Administration",
      icon: Settings,
      path: userType === "U" ? "/accountnames" : "/settingsuser",
      isActive: [
        "/settingsuser",
        "/list",
        "/accountnames",
        "/registration",
      ].includes(pathName),
    },
  ];

  const handleNavClick = (e, item) => {
    e.preventDefault();
    navigate(item.path);
    if (onItemClick) {
      onItemClick(item.id);
    }
    if (isMobile && closeSidebar) {
      closeSidebar();
    }
  };

const isWhiteTheme = theme === "white";

const smallLogo = isWhiteTheme
  ? SmallLogoForWhiteTheme
  : LogoSmall;

const largeLogo = isWhiteTheme
  ? LogoForWhiteTheme
  : LargeSmall;

  return (
    <div
      className={`h-full flex flex-col transition-all duration-300 ${
        isCollapsed ? "ml-0" : "ml-0"
      }`}
      style={{
        backgroundColor: theme === "white" ? "#f8f9fa" : colors.background,
        borderRight: `1px solid ${colors.border}`,
        backdropFilter: "blur(10px)",
      }}
    >
      <div className="p-6 flex items-center justify-between">
        {isCollapsed ? (
  <img
    key="small-logo"
    src={smallLogo}
    alt="logo"
    className="w-[31px] h-[44px] object-contain shrink-0"
  />
) : (
  <img
    key="large-logo"
    src={largeLogo}
    alt="logo"
    className="w-[210px] h-[44px] object-contain shrink-0"
  />
)}

        {/* CLOSE BUTTON (only mobile) */}
        {window.innerWidth <= 767 && (
          <button
            onClick={() => window.dispatchEvent(new Event("closeSidebar"))}
            className="p-2 rounded-lg"
            aria-label="Open menu"
          >
            <X className="w-5 h-5" style={{ color: colors.text }} />
          </button>
        )}
      </div>

      <nav className="flex-1 px-4">
        <ul className="space-y-4 mt-6 p-0 list-none">
          {navItems.map((item) => {
            const Icon = item.icon;
            // Matches if the current path is exactly the item path OR if it's in the sub-routes list
            const isActive =
              item.isActive ?? pathName === item.path.toLowerCase();

            return (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={(e) => handleNavClick(e, item)}
                  className="w-full relative group"
                >
                  {/* Custom Tooltip */}
                  {/* <span
  className="absolute left-full top-1/2 -translate-y-1/2 ml-3
  backdrop-blur-sm text-xs font-semibold
  px-3 py-2 rounded-lg shadow-xl
  opacity-0 scale-95 invisible
  group-hover:opacity-100 group-hover:scale-100 group-hover:visible
  transition-all duration-200 ease-out
  whitespace-nowrap z-50"
 style={{
  backgroundColor: theme === "white" ? "#fff" : colors.cardBg,
  border: `1px solid ${theme === "white" ? "#d4d4d4" : colors.border}`,
  color: theme === "white" ? "#000" : colors.text,
}}
>
  {item.label}

  <span
    className="absolute left-[-6px] top-1/2 -translate-y-1/2 
    w-3 h-3 rotate-45 border-l border-t"
    style={{
      backgroundColor: theme === "white" ? "#1f2937" : colors.cardBg,
      borderColor: colors.border,
    }}
  />
</span> */}
                  <span
                    className="absolute left-full top-1/2 -translate-y-1/2 ml-3
  backdrop-blur-sm text-xs font-semibold
  px-3 py-2 rounded-lg shadow-xl
  opacity-0 scale-95 invisible
  group-hover:opacity-100 group-hover:scale-100 group-hover:visible
  transition-all duration-200 ease-out
  whitespace-nowrap z-50"
                    style={{
                      backgroundColor:
                        theme === "white"
                          ? "#daf0f9"
                          : theme === "teal"
                            ? "#133434"
                            : theme === "blue"
                              ? "#047098"
                              : colors.primary,
                      border: theme === "white" ? "1px solid #d4d4d4" : "none",
                      color: theme === "white" ? "#000" : "#fff",
                    }}
                  >
                    {item.label}

                    <span
                      className="absolute left-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 rotate-45"
                      style={{
                        backgroundColor:
                          theme === "white"
                            ? "#daf0f9"
                            : theme === "teal"
                              ? "#4a9b8e"
                              : theme === "blue"
                                ? "#047098"
                                : colors.primary,
                      }}
                    />
                  </span>
                  {isActive && (
                    <div
                      className="absolute left-0 top-0 bottom-0 w-1 rounded-r-full"
                      style={{ backgroundImage: colors.gradient }}
                    />
                  )}

                  <div
                    className="relative flex items-center gap-4 px-4 py-4 rounded-lg transition-all duration-300 overflow-hidden hover:translate-x-1"
                    style={{
                      color: isActive ? colors.text : colors.textSecondary,
                      background: isActive
                        ? `linear-gradient(to right, ${colors.primary}25, transparent)`
                        : "transparent",
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive)
                        e.currentTarget.style.backgroundColor = `${colors.primary}12`;
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive)
                        e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <div className="relative z-10">
                      <div className="relative">
                        <div className="absolute inset-0 translate-x-0.5 translate-y-0.5 opacity-30">
                          <Icon
                            className="w-5 h-5"
                            style={{
                              color: isActive ? colors.primary : colors.border,
                            }}
                          />
                        </div>
                        <div
                          className="relative"
                          style={{
                            filter: isActive
                              ? "drop-shadow(0 0 6px rgba(0, 184, 241, 0.6))"
                              : "none",
                          }}
                        >
                          <Icon
                            className="w-5 h-5"
                            style={{
                              color: isActive
                                ? colors.primary
                                : colors.textSecondary,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {!isCollapsed && (
                      <span className="relative z-10 font-medium">
                        {item.label}
                      </span>
                    )}
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* <div className="p-4" style={{ borderTop: `1px solid ${colors.border}` }}>
       
      </div> */}
    </div>
  );
}
